import { Selection } from "src/hooks/useMultiselectState";
import { BulkTargets, SchoolFormKeyRecord } from "../types";

export function resolveBulkTargets(
  selection: Selection<SchoolFormKeyRecord, unknown>,
  formTemplateId: uuid,
  cacheKey?: uuid | null
): BulkTargets | null {
  const selectedOrExcluded = selection.keysIncludedOrExcluded.map((key) =>
    key.toObject()
  );

  if (selection.isInclusive) {
    if (selectedOrExcluded.length === 0) return null;
    return { inclusion: selectedOrExcluded, formTemplateId };
  }

  if (!cacheKey) return null;
  return { cacheKey, exclusion: selectedOrExcluded, formTemplateId };
}
